export default __webpack_public_path__ + "static/media/fashion.cd601b8c.jpg";